export type PriceRecord = Record<string, number | null | undefined> | null;

export const prefixYears = (obj: Record<string, any> | null) => {
  if (!obj) return null;
  const out: Record<string, any> = {};
  Object.keys(obj).forEach((k) => {
    out[`year${k}`] = obj[k];
  });
  return out;
};

export const formatDateOnly = (value?: string | Date | null): string | null => {
  if (!value) return null;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const d = typeof value === 'string' ? new Date(value) : (value as Date);
  if (isNaN(d.getTime())) return null;
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export function normalizeProjected(obj: Record<string, any> | null | undefined): Record<string, number | null> {
  const out: Record<string, number | null> = {};
  if (!obj) return out;
  Object.keys(obj).forEach((k) => {
    const normalizedKey = k.startsWith('year') ? k : `year${k}`;
    const val = (obj as Record<string, any>)[k];
    out[normalizedKey] = val == null ? null : Number(val);
  });
  return out;
}

export function expandProjectedToBothKeys(obj: Record<string, any> | null | undefined): Record<string, number> {
  const proj = normalizeProjected(obj);
  const out: Record<string, number> = {};
  Object.keys(proj).forEach((yearKey) => {
    const val = proj[yearKey];
    if (val == null) return;
    out[yearKey] = val;
    const plain = yearKey.replace(/^year/, '');
    out[plain] = val;
  });
  return out;
}
